import { DonorListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';
import { formatInterval } from 'modules/common/utils/formatInterval';

export const createIndividualDonorChipsConfig = (
  t: TFunction
): FiltersConfig<DonorListFilterInput> => ({
  statuses: {
    label: t('status'),
    renderValue: formatEnum,
  },
  bloodType: {
    label: t('bloodType'),
    renderValue: (val) => String(val).replace('_', ''),
  },
  locations: {
    label: t('location'),
  },
  lastDonationInterval: {
    label: t('lastDonation'),
    renderValue: formatInterval,
  },
});

export const excludedFilterFields: (keyof DonorListFilterInput)[] = [
  'searchingQuery',
  'types',
  'isDaycare',
  'groupId',
  'teamId',
  'name',
];
